export const apiEndpoints = {
    restaurant: `/restaurant`,
    qrDetails: `/qr/details`,
};

export default apiEndpoints;
